import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TypePresetVarType = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
}) => {
  const { t } = useTranslation();

  function handleChange(e) {
    updateValidationOnChange(field.key, e.target.value);
  }

  return (
    <FormControl fullWidth>
      <InputLabel id={'type-preset-var-type-' + field.key}>
        {field.label}
      </InputLabel>
      <Select
        labelId={'type-preset-var-type-' + field.key}
        value={dataCollection[field.key]}
        label={field.label}
        onChange={handleChange}
      >
        <MenuItem value={'date'}>{t('Date')}</MenuItem>
        <MenuItem value={'money'}>{t('Money')}</MenuItem>
        <MenuItem value={'text'}>{t('Text')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default TypePresetVarType;
